module.exports = __webpack_public_path__ + "static/media/badge2.9567644d.svg";